import(/* webpackMode: "eager" */ "/app/node_modules/@akinon/next/components/image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@akinon/next/components/mobile-app-toggler.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@akinon/next/utils/get-currency.ts");
;
import(/* webpackMode: "eager" */ "/app/src/components/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/components/shadcn/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTopButton"] */ "/app/src/views/back-to-top-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderBandLink"] */ "/app/src/views/header/header-bank-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/header/mini-basket-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/header/mobile-hamburger-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/header/mobile-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/header/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchForm"] */ "/app/src/views/header/search/form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchPlaceholderBar"] */ "/app/src/views/header/search/placeholder-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserMenu"] */ "/app/src/views/header/user-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/root-modal.tsx");
